import { createRouter, createWebHistory } from 'vue-router'
import webVitals from '@/plugins/web-vitals'

import Home from '@/pages/Home'

const defaultStoreUri = process.env.VUE_APP_STORE_URL

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
	},
	{
		path: '/about',
		name: 'About',
		component: () => import('@/pages/About'),
	},
	{
		path: '/partnerships',
		name: 'Partnership',
		component: () => import('@/pages/Partnership'),
	},
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
})

router.beforeEach((to, from, next) => {
	if (!to.matched.length) {
		if (defaultStoreUri) {
			window.location.href = `${defaultStoreUri}${to.fullPath}`
			return
		}
		next({ path: '/', query: to.query, replace: true })
		return
	}

	if (Object.keys(from.query).length > 0) {
		const mergedQuery = { ...to.query, ...from.query }
		if (JSON.stringify(to.query) !== JSON.stringify(mergedQuery)) {
			next({ ...to, query: mergedQuery, replace: true })
		}
	}

	next()
})

webVitals(router)

export default router
